module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bPPvb"))).then(() => parcelRequire('fCZtV'));